module.exports = __webpack_public_path__ + "static/media/sales-order-slide-5.62c109fe.jpg";